// Fix viewport scaling on iOS devices
const viewportTag = document.querySelector("[name=viewport]");
if (viewportTag && /iPhone|iPad|iPod/.test(navigator.userAgent)) {
    viewportTag.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1");
}
